export default {"src":"/_next/static/media/verificationid.de919605.svg","height":31,"width":32,"blurWidth":0,"blurHeight":0};